import React from "react";

// reactstrap components
import { Container, Row } from "reactstrap";

class Header extends React.Component {
  render() {
    return (
      <>
        <div
          className="header bg-gradient-info  pt-5 pt-md-8"
          style={{ paddingBottom: "1rem " }}
        >
          <Container fluid>
            <div className="header-body">
              <Row></Row>
            </div>
          </Container>
        </div>
      </>
    );
  }
}

export default Header;
